
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import Login from "./Login";
import Dashboard from "./Dashboard";
import Register from "./Register";
import AdminDashboard from "./AdminDashboard";
import StudentProjectDetails from "./StudentProjectDetails";
import { useEffect} from "react";
import OpeningPage from "./pages/OpeningPage";


import ProjectDetails from "./components/ProjectDetails"; // ✅ Import the component
/*
function Home() {
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>Welcome</h1>
      <button onClick={() => navigate("/login")} style={{ margin: "10px", padding: "10px 20px" }}>
        Login
      </button>
      <button onClick={() => navigate("/register")} style={{ margin: "10px", padding: "10px 20px" }}>
        Register as Student
      </button>
    </div>
  );
}
*/
function LogoutButton({ setToken }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    setToken(null);
    navigate("/login");
  };

  return (
    <button onClick={handleLogout} style={{ position: "absolute", top: 10, right: 10, padding: "10px 20px" }}>
      Logout
    </button>
  );
}


function Layout({ children, token, setToken }) {
  const location = useLocation();

  // Hide logout button on login and register pages
  const showLogout = token && location.pathname !== "/login" && location.pathname !== "/register";

  return (
    <>
      {showLogout && <LogoutButton setToken={setToken} />}
      {children}
    </>
  );
}

function App() {
  const [token, setToken] = useState(null);

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      setToken(storedToken);
    }
  }, []);

  console.log("App token state:", token);
  return (
    <Router>
      <Layout token={token} setToken={setToken}>
        <Routes>
          <Route path="/" element={<OpeningPage />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login setToken={setToken} />} />
          <Route path="/dashboard" element={token ? <Dashboard /> : <Navigate to="/login" />} />
          <Route path="/admindashboard" element={token ? <AdminDashboard /> : <Navigate to="/login" />} />
          <Route path="/project/:project_id" element={<StudentProjectDetails />} />
          <Route path="/admin/project/:id" element={<ProjectDetails />} /> {/* ✅ Added dynamic route */}
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;